<div class="main-menu">
  <div class="wrapper">
    <div>
      <img src="/assets/mylab_logo.png" id="mylab-logo">
    </div>
    <ul nz-menu nzMode="horizontal">
      <li nz-menu-item *ngFor="let menuLink of (menuLinks$ | async)" [nzSelected]="menuLink.url == currentRoute" [id]="menuLink.id">
        <a [id]="menuLink.id+'-link'" *ngIf="menuLink.external;else app_route_link" href="{{menuLink.url}}" target="_blank">{{menuLink.name |
          titlecase}}</a>
        <ng-template #app_route_link>
          <a *ngIf="menuLink.fullDocumentNavigation; else routerNavigation" [href]="menuLink.url" [id]="menuLink.id+'-link'">{{menuLink.name | titlecase}}</a>
          <ng-template #routerNavigation><a [routerLink]="menuLink.url" [id]="menuLink.id+'-link'">{{menuLink.name | titlecase}}</a></ng-template>
        </ng-template>
      </li>
    </ul>
  </div>
</div>
